import { useContext, useState } from 'react'
import { CertificateData } from '@big-red-group/storefront-common-checkout'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { useSession } from 'next-auth/react'
import { extractEvProductIdsFromCertificates } from '@/helpers/CustomerHelper'
import { logger } from '@/logging/Logger'

const log = logger()

export const useCustomerCertificates = () => {
  const defaultPropertiesContext = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultPropertiesContext?.agentConfiguration?.handlerKey)
  const [certificates, setCertificates] = useState<CertificateData[]>([])
  const { update } = useSession()

  const loadCertificates = async () => {
    try {
      const fetchedCertificates = await fetchCertificates()
      const evProductIds = extractEvProductIdsFromCertificates(fetchedCertificates)
      await update({ evProductIds })
      setCertificates(fetchedCertificates)
    } catch (e) {
      const errorMessage = 'Failed to load customer certificates'
      log.error(errorMessage)
    }
  }

  const fetchCertificates = async (): Promise<CertificateData[]> => {
    const response = await fetch(`${baseUrl}/api/customer/certificates`, {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error('Failed to fetch customer certificates')
    }
    return response.json()
  }

  return {
    certificates,
    loadCertificates,
  }
}
